import  { useEffect, useState } from "react";
import Select from "react-select";
import { connect } from "react-redux";
import { getAllFinacManagerAction, resetSession } from "../../../redux/auth";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import {
  resetMySpaceError,
  resetMySpaceMessage,
  resetMySpaceSuccess,
} from "../../../redux/mySpace";
import { RootState } from "../../../redux/rootReducers";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import useDebounce from "../../../customHooks/useDebounce";
import { CircularAvatar } from "../../commons";
import { components } from "react-select";
import ReportsDateSelect from "../../commons/ReportsDateSelect/ReportsDateSelect";
import { handleDate } from "../../../utils/commonFunctions";
import ImageModal from "../../../screens/AdminReports/OpenItemsProgressReports/ImageModal";
import MultipleUpload from "../../commons/Upload/MultipleUpload";
import { UploadFileTypesPayload } from "../../../commonTypes/fileManagerTypes";
import { singleImagePreview } from "../../../utils/invoiceGeneration/commonFunctions";
import { PaperClipIcon } from "../../Icon";
import { AddPerformanceEvaluationPayloadType } from "../../../commonTypes/mySpaceType";
import MultiUploadWithApi from "../../commons/UploadFileWithApi/MultiUploadWithApi";
import { MulitpleFileUploadData } from "../../../redux/clientSettings/clientSettingTypes";
import { StockUploadFilePayloadType } from "../../../commonTypes/clientSettingsTypes";
import { multipleUploadFilesAction, resetMultipleFileUploadData, resetMultipleFileUploadError, resetMultipleFileUploadFetching, resetMultipleFileUploadSuccess } from "../../../redux/clientSettings";
import MultiFilePreviewModal from "../../commons/MultiPreviewWithApi/MultiFilePreviewModal";
type DropDown = { label: string; value: null | number };

type AppProps = {
  token: null | string;
  history: any;
  fetching: boolean;
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) => void;
  message: string | null;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  finacManagerList: any;
  loginData: LoginResponseType;
  totalManagerCount: string | number;
  fileUploadData:MulitpleFileUploadData[]|[];
  fileUploadSuccess:number|null;
  fileUploadFetching:boolean;
  dispatchResetFileUploadError:()=>void;
  dispatchResetFileUploadSuccess:()=>void;
  dispatchUploadFilesAction:(data:StockUploadFilePayloadType)=>void;
  dispatchResetFileUploadFetching:()=>void;
  dispatchResetFileUploadData:()=>void;
  dispatchResetMySpaceSuccess: () => void;
  dispatchResetMySpaceMessage: () => void;
  dispatchResetMySpaceError: () => void;
  dispatchResetSession: () => void;
  handleAddPerformanceEvaluation: (
    data: AddPerformanceEvaluationPayloadType
  ) => void;
};
const PerformanceEvaluationFormData = ({
  token,
  history,
  fetching,
  dispatchGetAllFinacManagerAction,
  message,
  error,
  success,
  statusCode,
  finacManagerList,
  loginData,
  totalManagerCount,
  fileUploadData,
  fileUploadSuccess,
  fileUploadFetching,
  dispatchResetFileUploadError,
  dispatchResetFileUploadSuccess,
  dispatchUploadFilesAction,
  dispatchResetFileUploadFetching,
  dispatchResetFileUploadData,
  dispatchResetMySpaceSuccess,
  dispatchResetMySpaceMessage,
  dispatchResetMySpaceError,
  dispatchResetSession,
  handleAddPerformanceEvaluation,
}: AppProps) => {
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;
  let containerName: string | undefined =
    process.env.REACT_APP_USER_CONTAINER_NAME;

  const [performanceEvaluationData, setPerformanceEvaluationData] = useState({
    projectTitle: "",
    manager: { label: "Select", value: null },
    hours: "",
    startDate: "",
    endDate: "",
    fileAttachements: {},
  });
  const [finalManagerList, setFinalManagerList] = useState<any>([]);
  const [managerText, setManagerText] = useState<string>("");
  const [managerLimit, setManagerLimit] = useState<number>(20);
  const [managerOffset, setManagerOffset] = useState<number>(0);
  const [toggle, setToggle] = useState<boolean>(false);
  const [showFileUploadModal, setShowFileUploadModal] =
    useState<boolean>(false);
  const [showPopUpContentModal, setShowPopUpContentModal] =
    useState<boolean>(false);
  const [showImagePreview, setShowImagePreview] = useState<boolean>(false);
  const [uploadSuccessArray, setUploadSuccessArray] = useState<any>([]);
  const [uploadData, setUploadData] = useState<any>([]);
  const [imageDetails, setImageDetails] = useState<any>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  const [modal, toggleModal] = useState<boolean>(false);

  useEffect(()=>{
        dispatchResetFileUploadFetching();
        dispatchResetFileUploadData();
        dispatchResetFileUploadSuccess();
        dispatchResetFileUploadError();
        
      },[])
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatchResetMySpaceError();
    dispatchResetMySpaceMessage();
    dispatchResetMySpaceSuccess();
  }, []);
  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: managerOffset,
        limit: managerLimit,
        user_type: "manager",
        status: 1,
        search_term: managerText,
      };
      if (managerOffset <= +totalManagerCount) {
        dispatchGetAllFinacManagerAction(finalUserData);
      }
    }
  }, [managerOffset]);

  useEffect(() => {
    const data = finacManagerList?.filter(
      (e: any) => e?.user_id !== loginData?.user_id
    );
    const finalManagerData = data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${
          user?.last_name ? user?.last_name : ""
        }%${user?.job_title ? user?.job_title : ""} ${
          user?.department ? "|" : ""
        } ${user?.department !== null ? user?.department : ""}`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (managerOffset > 0) {
      setFinalManagerList([...finalManagerList, ...finalManagerData]);
    } else {
      setFinalManagerList(finalManagerData);
    }
  }, [finacManagerList]);

  const fetchNewManagerData = (search: string) => {
    const finalData = {
      token,
      offset: managerOffset,
      limit: managerLimit,
      user_type: "manager",
      status: 1,
      search_term: managerText,
    };
    dispatchGetAllFinacManagerAction(finalData);
  };
  const handleManagerDropdownChange = (data: DropDown) => {
    setPerformanceEvaluationData((prev: any) => {
      return {
        ...prev,
        manager: {
          value: data.value,
          label: data?.label?.split("%")[0],
        },
      };
    });
  };

  const checkBottom = () => {
    setManagerOffset((prev: any) => prev + managerLimit);
  };
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  useDebounce(
    () => {
      if (managerText) {
        fetchNewManagerData(managerText);
      } else {
        const finalData = {
          token,
          offset: managerOffset,
          limit: managerLimit,
          user_type: "manager",
          status: 1,
          search_term: managerText,
        };
        dispatchGetAllFinacManagerAction(finalData);
      }
    },
    500,
    [managerText]
  );

  const handleGoBack = () => {
    history?.push({ pathname: `/my-space` });
  };

  // file upload
  const handleUploadFile = (data: UploadFileTypesPayload) => {
    setImageDetails(data);
    setShowFileUploadModal(false);
    setUploadData((prevUploadData: any) => [...prevUploadData, data]);
  };

  useEffect(() => {
    if (showImagePreview && uploadData?.length) {
      getImageDetails({ ...uploadData[0] }, 0);
    }
  }, [showImagePreview, uploadData]);
  const handleEditFileList = (index: number) => {
    const tempFileData = JSON.parse(JSON.stringify(uploadData));
    const updatedFiles = [...uploadData];
    setUploadData(updatedFiles?.filter((e: any) => e?.file_url !== index));
  };
  const resetImageUrl = () => {
    setImageDetails({
      imageUrl: "",
      downloadImage: "",
      fileType: "",
      finalFileName: "",
      updateBy: "",
      updatedAt: "",
    });
  };
  const showUploadModal = () => {
    toggleModal(!modal);
  };
  const getImageDetails = (data: any, index: any) => {
    setImageDetails({
      ...data,
      imageUrl: blobBaseUrl + data?.file_url + "?" + blobToken,
      downloadImage: data?.file_url,
      fileType: data?.file_type,
      finalFileName: data?.file_name,
    });
  };
  const renderFilesList = () => {
    const isDelete = false;
    const finalFileList =
      uploadData?.length > 0 &&
      uploadData?.map((data: any, index: number) => {
        return singleImagePreview(
          data,
          index,
          getImageDetails,
          handleEditFileList,
          setShowPopUpContentModal,
          isDelete,
          uploadData
        );
      });
    return finalFileList;
  };

  const handleProjectTitleChange = (data: string) => {
    setPerformanceEvaluationData((prev: any) => {
      return {
        ...prev,
        projectTitle: data,
      };
    });
  };
  const handlehoursChange = (data: any) => {
    setPerformanceEvaluationData((prev: any) => {
      return {
        ...prev,
        [data.target.name]: data.target.value,
      };
    });
  };

  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setPerformanceEvaluationData((prev) => ({
      ...prev,
      startDate: value,
    }));
  };

  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setPerformanceEvaluationData((prev) => ({
      ...prev,
      endDate: value,
    }));
  };

  const handleSubmit = () => {
    Object.keys(performanceEvaluationData)?.forEach((key) => {
      performanceEvaluationData["fileAttachements"] = uploadData;
    });
    const finalData = {
      title: performanceEvaluationData?.projectTitle,
      manager: performanceEvaluationData?.manager?.value,
      startDate: performanceEvaluationData?.startDate,
      endDate: performanceEvaluationData?.endDate,
      hours: performanceEvaluationData?.hours,
      attachments: performanceEvaluationData?.fileAttachements,
    };
    handleAddPerformanceEvaluation(finalData);
  };

  // const handleFileChange = (file: any) => {
  //   const finalData = {
  //     token,
  //     fileData: file,
  //   };
  //   return dispatchUploadFilesAction(finalData);
  // }
  return (
    <>
      <div>
        <p style={{ fontSize: "20px", fontWeight: "500" }} className="mb-3">
          Add New PE Form
        </p>
        <div className="row mb-3">
          <div className="col-md-4">
            <label className="mb-1" htmlFor="projectTitle">
              Title <span className="color-red">*</span>
            </label>
            <div>
              <input
                type="text"
                className={`form-control `}
                name="name"
                onChange={(e) => handleProjectTitleChange(e.target.value)}
                value={performanceEvaluationData?.projectTitle}
              />
            </div>
          </div>
          <div className="ml-3" style={{ width: "17%" }}>
            <label className="mb-1" htmlFor="hours">
              Total Hours Spent
            </label>
            <div>
              <input
                type="number"
                name="hours"
                className="form-control"
                value={performanceEvaluationData?.hours}
                onChange={handlehoursChange}
                onWheel={(event) => event.currentTarget.blur()}

              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="mt-4 col-md-4">
            <label className="mb-1">Select Manager <span className="color-red">*</span></label>
            <Select
              value={performanceEvaluationData?.manager}
              options={finalManagerList}
              onChange={(e: any) => handleManagerDropdownChange(e)}
              onMenuScrollToBottom={checkBottom}
              components={{ Option }}
              onInputChange={(e: any) => {
                setManagerText?.(e);
              }}
            />
          </div>
          <div className="form-group mt-4 ml-3">
            <label className="mb-1">Date Range <span className="color-red">*</span></label>
            <div>
              <ReportsDateSelect
                setToggle={setToggle}
                toggle={toggle}
                startDate={
                  performanceEvaluationData?.startDate
                    ? performanceEvaluationData?.startDate
                    : ""
                }
                endDate={
                  performanceEvaluationData?.endDate
                    ? performanceEvaluationData?.endDate
                    : ""
                }
                handleStartDateChange={handleStartDateChange}
                handleEndDateChange={handleEndDateChange}
                type={"performanceEvaluation"}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 mt-1 mb-3 mt-4 d-flex pl-4">
            <div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <button
                  className="btn btn-outline"
                  onClick={() => {
                    showUploadModal();
                  }}
                >
                  + Upload File
                </button>
                <div className="pointer position-relative ml-4">
                  {uploadData?.length ? (
                    <span
                      id="Popover1"
                      onClick={() => setShowImagePreview(true)}
                    >
                      <PaperClipIcon />
                      <span
                        className="badge count-badge"
                        style={{ left: "11px" }}
                      >
                        {uploadData?.length}
                      </span>
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr />
        <div className="row mt-5">
          <div className="col-md-12 text-right">
            <button
              className="btn"
              style={{ border: "1px solid #bfcbe1", marginRight: "15px" }}
              onClick={() => handleGoBack?.()}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={
                !performanceEvaluationData?.projectTitle ||
                !performanceEvaluationData?.manager ||
                !performanceEvaluationData?.startDate ||
                !performanceEvaluationData?.endDate
              }
            >
              Submit{" "}
            </button>
          </div>
        </div>
      </div>
      {/* {modal && (
        <MultiUploadWithApi
          modal={modal}
          toggleModal={showUploadModal}
          token={token}
          handleFileChange={handleFileChange}
          isDraggableModal
          acceptedFiles={"image/png, image/gif, application/pdf , image/jpeg, .csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"}
          maxFileSize={2000000}
          supportedFiles="PNG, JPEG, PDF, Excel, PPT, PPTX and Doc."
          allFileData={uploadData}
          setAllFileData={setUploadData}
          multipleFileUploadFetching={fileUploadFetching}
          multipleFileUploadSuccess={fileUploadSuccess}
          multipleFileUploadData={fileUploadData}
          dispatchResetMultipleFileUploadSuccess={dispatchResetFileUploadSuccess}
          dispatchResetMultipleFileUploadError={dispatchResetFileUploadError}
        />
      )} */}
      {/* {showImagePreview && (
        <MultiFilePreviewModal
          show={showImagePreview}
          files={uploadData}
          onClose={() => setShowImagePreview(false)}
          token={token}
          setAllFileData={setUploadData}
        />
      )} */}
      {modal ? (
        <MultipleUpload
          modal={modal}
          toggleModal={showUploadModal}
          containerName={containerName}
          handleUploadFile={handleUploadFile}
          isDraggableModal
          acceptedFiles="image/png, image/gif, application/pdf , image/jpeg, .csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"
          supportedFiles="PNG, JPEG, PDF, Excel, PPT, PPTX and Doc."
          uploadSuccessArray={uploadSuccessArray}
          setUploadSuccessArray={setUploadSuccessArray}
        />
      ) : null}
      {showImagePreview && (
        <ImageModal
          showImagePreview={showImagePreview}
          setShowImagePreview={setShowImagePreview}
          resetImageUrl={resetImageUrl}
          imageDetails={imageDetails}
          renderFilesList={renderFilesList}
          uploadData={uploadData}
          setUploadData={setUploadData}
          type={"jobDetails"}
          handleEditFileList={handleEditFileList}
          isDelete={true}
        />
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.mySpace.checkInScheduleFetching,
  finacManagerList: state.auth.finacManagerList,
  totalManagerCount: state.auth.totalManagerCount,
  message: state.mySpace.message,
  success: state.mySpace.success,
  statusCode: state.mySpace.statusCode,
  error: state.mySpace.error,
  loginData: state.auth.loginData,
  fileUploadFetching: state.clientSettings.multipleFileUploadFetching,
  fileUploadSuccess: state.clientSettings.multipleFileUploadSuccess,
  fileUploadError: state.clientSettings.multipleFileUploadError,
  fileUploadData: state.clientSettings.multipleFileUploadData
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacManagerAction(data)),

  dispatchResetMySpaceSuccess: () => dispatch(resetMySpaceSuccess()),
  dispatchResetMySpaceMessage: () => dispatch(resetMySpaceMessage()),
  dispatchResetMySpaceError: () => dispatch(resetMySpaceError()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetFileUploadSuccess: () => dispatch(resetMultipleFileUploadSuccess()),
  dispatchResetFileUploadError: () => dispatch(resetMultipleFileUploadError()),
  dispatchUploadFilesAction: (data: StockUploadFilePayloadType) =>dispatch(multipleUploadFilesAction(data)),
  dispatchResetFileUploadFetching:()=>dispatch(resetMultipleFileUploadFetching()),
  dispatchResetFileUploadData:()=>dispatch(resetMultipleFileUploadData()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PerformanceEvaluationFormData);
